import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './app.component.html'
})
/* v8 ignore start */
export class AppComponent {}
/* v8 ignore stop */
